// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scissor-text[data-v-0749a500]{color:#fff}.scissor-left[data-v-0749a500],.scissor-right[data-v-0749a500]{width:100%;height:100%}@media (min-width:1024px){.scissor-text[data-v-0749a500]{color:#000}.scissor-right[data-v-0749a500]{margin-left:50%}.scissor-left[data-v-0749a500],.scissor-right[data-v-0749a500]{width:50%;height:100%}}", ""]);
// Exports
module.exports = exports;
